import { IIntegration } from '@api/integration/types'

export function meridianEnabled(activeIntegrations: IIntegration[]) {
  return Boolean(activeIntegrations.find(({ source }) => source === 'meridian'))
}
